import { BrowserService } from './browser.service';
import { Injectable } from '@angular/core';
import { DatexPipe } from '../pipe/datex.pipe';
import { KeycodeService } from './keycode.service';


@Injectable()
export class DateService {

  datePipe: DatexPipe = new DatexPipe();

  constructor(private browser: BrowserService,
    private keycodeService: KeycodeService) {
  }

  nowYYYYMMDD() {
    return this.getYYYYMMDD(new Date());
  }

  getYYYYMMDD(date: Date) {
    return this.datePipe.transform(date, 'YYYY-MM-DD');
  }

  getFormatDate(date: Date, format: string) {
    return this.datePipe.transform(date, format);
  }

  validateDate(inputText, format: RegExp, err) {
    // 1800-01-01 ~ 9999-12-31
    let dateformat = /^(1?(8|9)[0-9]{2}|[2-9][0-9]{3})[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;
    if (format) {
      dateformat = format;
    }
    // Match the date format through regular expression
    if (inputText.match(dateformat)) {
      // document.form1.text1.focus();
      // Test which seperator is used '/' or '-'
      const opera1 = inputText.split('/');
      const opera2 = inputText.split('-');
      const lopera1 = opera1.length;
      const lopera2 = opera2.length;
      // Extract the string into month, date and year
      let pdate = '';
      if (lopera1 > 1) {
        pdate = inputText.split('/');
      } else if (lopera2 > 1) {
        pdate = inputText.split('-');
      }
      const yy = parseInt(pdate[0]);
      const mm = parseInt(pdate[1]);
      const dd = parseInt(pdate[2]);
      // Create list of days of a month [assume there is no leap year by default]
      const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (mm === 1 || mm > 2) {
        if (dd > ListofDays[mm - 1]) {
          err.str = 'Invalid date format! (Month) - ' + yy + '-' + mm + '-' + dd;
          return false;
        }
      }
      if (mm === 2) {
        let lyear = false;
        if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
          lyear = true;
        }
        if ((lyear === false) && (dd >= 29)) {
          err.str = 'Invalid date format! (Day) - ' + yy + '-' + mm + '-' + dd;
          return false;
        }
        if ((lyear === true) && (dd > 29)) {
          err.str = 'Invalid date format! (Day) - ' + yy + '-' + mm + '-' + dd;
          return false;
        }
      }

      return true;
    } else {
      err.str = 'Invalid date format! match failed. - ' + inputText;
      return false;
    }
  }

  /**
   * Not check input data.
   * If you want to check input data, using onCheckDate()
   *
   * @param e Keyboard event
   */
  private defaultDateChangeEvent(e) {
    // IE이거나 Edge인 경우 수행
    if (this.browser.isIE() === false
      && this.browser.isEdge() === false) {
      return;
    }

    const len = e.currentTarget.value.length;

    // If we're at a particular place, let the user type the slash
    // i.e., 12/12/1212
    if (len !== 5 || len !== 8) {
      if (e.keyCode === 45) {
        e.preventDefault();
        return;
      }
    }

    // If they don't add the slash, do it for them...
    if (len === 4 && e.keyCode !== 8) {
      e.currentTarget.value += '-';
    } else if (len > 4 && e.currentTarget.value.indexOf('-') < 0 && len < 7) {
      let tmp: string = e.currentTarget.value;
      tmp = tmp.replace('-', '');
      e.currentTarget.value = tmp.substr(0, 4) + '-' + tmp.substr(4, len);
    }

    // If they don't add the slash, do it for them...
    if (len === 7 && e.keyCode !== 8) {
      e.currentTarget.value += '-';
    } else if (len > 7 && e.currentTarget.value.split('-').length !== 3) {
      let tmp = e.currentTarget.value;
      tmp = tmp.replace('-', '');
      e.currentTarget.value = tmp.substr(0, 4) + '-' + tmp.substr(4, 2) + '-' + tmp.substr(6, 2);
    }

    // if (e.currentTarget.value.length === 10) {
    //   const err = {str: ''};
    //   if (this.validateDate(e.currentTarget.value, null, err) === false) {
    //     e.currentTarget.focus();
    //     e.currentTarget.select();
    //     if (err.str) {
    //       this.ac.alert(err.str);
    //     }
    //     return;
    //   }
    // }
  }

  defaultValueInit(event) {
    if (!event.currentTarget.value) {
      event.currentTarget.value = '';
    }
  }

  onCheckDate(event) {
    if (!this.keycodeService.isDateKey(event)) {
      event.preventDefault();
      return;
    }

    this.defaultDateChangeEvent(event);

    if (event.type === 'keyup'
      && event.currentTarget.value && event.currentTarget.value.length === 10) {
      event.currentTarget.blur();
    }
  }

  compare(first, second) {
    let fval: Date;
    if (typeof first === 'string') {
      fval = new Date(Date.parse(first));
    } else {
      fval = first;
    }
    fval.setHours(0);
    fval.setMinutes(0);
    fval.setSeconds(0);
    fval.setMilliseconds(0);

    let sval: Date;
    if (typeof second === 'string') {
      sval = new Date(Date.parse(second));
    } else {
      sval = second;
    }
    sval.setHours(0);
    sval.setMinutes(0);
    sval.setSeconds(0);
    sval.setMilliseconds(0);

    if (fval < sval) {
      return 1;
    } else if (fval > sval) {
      return -1;
    } else {
      return 0;
    }
  }

  getAfterDays(date, days: number) {
    let fval: Date;
    if (typeof date === 'string') {
      fval = new Date(Date.parse(date));
    } else {
      fval = date;
    }
    fval.setDate(fval.getDate() + days);
    return fval;
  }

  getAfterDaysWithFormat(date, days: number, format: string) {
    const val: Date = this.getAfterDays(date, days);
    return this.getFormatDate(val, format);
  }

  getAfterDaysAsYYYYMMDD(date, days: number) {
    const val: Date = this.getAfterDays(date, days);
    return this.getYYYYMMDD(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/date.service.ts